const lang_list = [
  { browser: "auto", config: "auto", value: "Auto", label: "auto_mark" },
  { browser: "en", config: "English", value: "English", label: "English" },
  { browser: "de", config: "German", value: "German", label: "Deutsch" },
  { browser: "zh", config: "Chinese", value: "Chinese", label: "中文" },
  { browser: "ja", config: "Japanese", value: "Japanese", label: "日本語" },
  { browser: "ko", config: "Korean", value: "Korean", label: "한국어" },
  { browser: "ru", config: "Russian", value: "Russian", label: "Русский" },
  { browser: "es", config: "Spanish", value: "Spanish", label: "Español" },
  { browser: "pl", config: "Polish", value: "Polish", label: "Polski" },
  { browser: "fr", config: "French", value: "French", label: "Français" },
  { browser: "it", config: "Italian", value: "Italian", label: "Italiano" },
  { browser: "sv", config: "Swedish", value: "Swedish", label: "Svenska" },
  { browser: "da", config: "Danish", value: "Danish", label: "Dansk" },
  { browser: "nl", config: "Dutch", value: "Dutch", label: "Nederlands" },
  { browser: "el", config: "Greek", value: "Greek", label: "Ελληνικά" },
  { browser: "no", config: "Norwegian", value: "Norwegian", label: "Norsk" },
  { browser: "cs", config: "Czech", value: "Czech", label: "Čeština" },
  { browser: "sl", config: "Slovenian", value: "Slovenian", label: "Slovenščina" },
  { browser: "pt", config: "Portuguese", value: "Portuguese", label: "Português" },
  { browser: "hu", config: "Hungarian", value: "Hungarian", label: "Magyar" },
  { browser: "ro", config: "Romanian", value: "Romanian", label: "Română" },
  { browser: "fi", config: "Finnish", value: "Finnish", label: "Suomi" },
  { browser: "sk", config: "Slovak", value: "Slovak", label: "Slovenčina" },
  { browser: "tr", config: "Turkish", value: "Turkish", label: "Türkçe" },
  {
    browser: "zh-tw",
    config: "Traditional-Chinese",
    value: "Traditional-Chinese",
    label: "繁體中文",
  },
  { browser: "ar", config: "Arabic", value: "Arabic", label: "ﺎﻠﻋﺮﺒﻳﺓ" },
];

export const lang = {
  lang: lang_list,
};

export default lang;
